export class Vehicle {
  id?: number;
  type: string; // enum {V: car, L: truck. etc...}
  plate: string;

  constructor(opts?: Vehicle) {
    Object.assign(this as Object, opts || {});
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/model/vehicle.ts